import { apiRequest } from './client'
import type { AutomationAction, AutomationCatalog, AutomationCondition, AutomationLogEntry, AutomationRule, TriggerType } from './types'

export const automationApi = {
  list: (projectId?: string) => apiRequest<{ data: AutomationRule[] }>('/automation', { query: { projectId } }),

  catalog: () => apiRequest<{ data: AutomationCatalog }>('/automation/catalog'),

  create: (input: {
    projectId?: string
    name: string
    enabled?: boolean
    triggerType: TriggerType
    triggerConfig?: Record<string, unknown>
    conditions?: AutomationCondition[]
    actions: AutomationAction[]
  }) => apiRequest<{ data: AutomationRule }>('/automation', { method: 'POST', body: input }),

  update: (
    id: string,
    input: Partial<{
      name: string
      enabled: boolean
      triggerType: TriggerType
      triggerConfig: Record<string, unknown>
      conditions: AutomationCondition[]
      actions: AutomationAction[]
    }>,
  ) => apiRequest<{ data: AutomationRule }>(`/automation/${id}`, { method: 'PATCH', body: input }),

  remove: (id: string) => apiRequest<{ data: { success: boolean } }>(`/automation/${id}`, { method: 'DELETE' }),

  logs: (id: string) => apiRequest<{ data: AutomationLogEntry[] }>(`/automation/${id}/logs`),

  dryRun: (id: string, taskId: string) =>
    apiRequest<{ data: { conditionsMatch: boolean; results: { type: string; success: boolean; detail: string; error?: string }[] } }>(
      `/automation/${id}/dry-run`,
      { method: 'POST', body: { taskId } },
    ),
}
